__webpack_require__.p = "https://lens.snapchat.com/_next/";